import { NgStyle } from '@angular/common';
import * as i0 from '@angular/core';
import { input, model, viewChild, signal, computed, output, effect, Component, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { toObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';
const _c0 = ["track"];
const _c1 = (a0, a1, a2) => [a0, a1, a2];
function NgxSliderComponent_Conditional_2_Conditional_1_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const index_r2 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(index_r2 * ctx_r2.maxValue() / (ctx_r2.ticks().length - 1));
  }
}
function NgxSliderComponent_Conditional_2_Conditional_1_For_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const index_r4 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(index_r4 * ctx_r2.maxValue() / (ctx_r2.ticks().length - 1));
  }
}
function NgxSliderComponent_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11)(1, "span", 12);
    i0.ɵɵrepeaterCreate(2, NgxSliderComponent_Conditional_2_Conditional_1_For_3_Template, 2, 1, "span", 13, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "span", 14);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 15);
    i0.ɵɵtext(7, "\u062A\u0627");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 11)(9, "span", 12);
    i0.ɵɵrepeaterCreate(10, NgxSliderComponent_Conditional_2_Conditional_1_For_11_Template, 2, 1, "span", 13, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "span", 16);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", ctx_r2.getMinNumberSliderTransform());
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.ticks());
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.unitName());
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngStyle", ctx_r2.getMaxNumberSliderTransform());
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.ticks());
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.unitName());
  }
}
function NgxSliderComponent_Conditional_2_Conditional_2_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const index_r5 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(index_r5 * ctx_r2.maxValue() / (ctx_r2.ticks().length - 1));
  }
}
function NgxSliderComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11)(1, "span", 12);
    i0.ɵɵrepeaterCreate(2, NgxSliderComponent_Conditional_2_Conditional_2_For_3_Template, 2, 1, "span", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "span", 17);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", ctx_r2.getNumberSliderTransform());
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.ticks());
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.unitName());
  }
}
function NgxSliderComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, NgxSliderComponent_Conditional_2_Conditional_1_Template, 14, 4)(2, NgxSliderComponent_Conditional_2_Conditional_2_Template, 6, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("rtl", ctx_r2.isRtl())("ltr", !ctx_r2.isRtl());
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r2.type() === "Range" ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(2, ctx_r2.type() === "Default" ? 2 : -1);
  }
}
function NgxSliderComponent_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.value());
  }
}
function NgxSliderComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵlistener("mousedown", function NgxSliderComponent_Conditional_6_Template_div_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onThumbStart($event, "single"));
    })("touchstart", function NgxSliderComponent_Conditional_6_Template_div_touchstart_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onThumbStart($event, "single"));
    });
    i0.ɵɵtemplate(1, NgxSliderComponent_Conditional_6_Conditional_1_Template, 2, 1, "span", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("first", ctx_r2.isRtl())("grabbing", ctx_r2.isDragging());
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r2.sliderType() === "Slider" && ctx_r2.showTopLabel() ? 1 : -1);
  }
}
function NgxSliderComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵlistener("mousedown", function NgxSliderComponent_Conditional_7_Template_div_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onThumbStart($event, "min"));
    })("touchstart", function NgxSliderComponent_Conditional_7_Template_div_touchstart_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onThumbStart($event, "min"));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("grabbing", ctx_r2.isDragging())("last", ctx_r2.isRtl())("first", !ctx_r2.isRtl());
  }
}
function NgxSliderComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵlistener("mousedown", function NgxSliderComponent_Conditional_8_Template_div_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onThumbStart($event, "max"));
    })("touchstart", function NgxSliderComponent_Conditional_8_Template_div_touchstart_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onThumbStart($event, "max"));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("grabbing", ctx_r2.isDragging())("last", !ctx_r2.isRtl())("first", ctx_r2.isRtl());
  }
}
function NgxSliderComponent_Conditional_9_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 21);
  }
  if (rf & 2) {
    const i_r9 = ctx.$index;
    const ɵi_64_r10 = ctx.$index;
    const ɵ$count_64_r11 = ctx.$count;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("right", ctx_r2.isRtl() ? i_r9 * 100 / ctx_r2.range() + "%" : "unset")("left", !ctx_r2.isRtl() ? i_r9 * 100 / ctx_r2.range() + "%" : "unset");
    i0.ɵɵclassProp("first", ɵi_64_r10 === 0)("last", ɵi_64_r10 === ɵ$count_64_r11 - 1);
  }
}
function NgxSliderComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, NgxSliderComponent_Conditional_9_For_1_Template, 1, 8, "div", 20, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r2.ticks());
  }
}
function NgxSliderComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵlistener("click", function NgxSliderComponent_Conditional_10_Template_span_click_0_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.isRtl() ? ctx_r2.backwardButtonClick($event) : ctx_r2.forwardButtonClick($event));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 23);
    i0.ɵɵelement(2, "path", 24);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "span", 25);
    i0.ɵɵlistener("click", function NgxSliderComponent_Conditional_10_Template_span_click_3_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.isRtl() ? ctx_r2.forwardButtonClick($event) : ctx_r2.backwardButtonClick($event));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 23);
    i0.ɵɵelement(5, "path", 24);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("hide", ctx_r2.hideRightArrowButton())("invert", ctx_r2.invertRightArrowButtonColor());
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("hide", ctx_r2.hideLeftArrowButton())("invert", ctx_r2.invertLeftArrowButtonColor());
  }
}
function NgxSliderComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 27);
    i0.ɵɵelement(2, "path", 28)(3, "path", 29);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("invert", ctx_r2.invertIconColor())("is-rtl", ctx_r2.isRtl());
  }
}
function NgxSliderComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30)(1, "span", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 13);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("rtl", ctx_r2.isRtl())("ltr", !ctx_r2.isRtl());
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r2.minValue(), "", ctx_r2.unitSymbol(), "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r2.maxValue(), "", ctx_r2.unitSymbol(), "");
  }
}
const amountLabelLineHeight = 56; // px
let NgxSliderComponent = /*#__PURE__*/(() => {
  class NgxSliderComponent {
    constructor(destroyRef) {
      this.destroyRef = destroyRef;
      this.draggingThumb = null;
      this.sliderType = input.required();
      this.type = input('Default');
      this.stepSize = input(1);
      this.showLabel = input(true);
      this.showTopLabel = input(true);
      this.value = model(0);
      this.minValue = input(0);
      this.maxValue = input(100);
      this.selectedMinValue = input(this.minValue());
      this.selectedMaxValue = input(this.maxValue());
      this.selectedMinValue$ = toObservable(this.selectedMinValue);
      this.selectedMaxValue$ = toObservable(this.selectedMaxValue);
      this.unitName = input('');
      this.unitSymbol = input('');
      this.direction = input('rtl');
      this.track = viewChild('track');
      this.minRangeValue = signal(this.selectedMinValue());
      this.maxRangeValue = signal(this.selectedMaxValue());
      this.isDragging = signal(false);
      this.isRange = computed(() => this.type() === 'Range');
      this.isRtl = computed(() => this.direction() === 'rtl');
      this.hideForwardButton = computed(() => this.type() === 'Range' && this.maxRangeValue() === this.maxValue() || this.type() === 'Default' && this.value() === this.maxValue());
      this.hideBackwardButton = computed(() => this.type() === 'Range' && this.minRangeValue() === this.minValue() || this.type() === 'Default' && this.value() === this.minValue());
      this.hideRightArrowButton = computed(() => this.isRtl() ? this.hideBackwardButton() : this.hideForwardButton());
      this.hideLeftArrowButton = computed(() => this.isRtl() ? this.hideForwardButton() : this.hideBackwardButton());
      this.invertForwardButtonColor = computed(() => {
        const track = this.track()?.nativeElement;
        if (track) {
          if (this.type() === 'Range' && this.maxRangeValue() * track.offsetWidth / 100 > track.offsetWidth - 20 || this.type() === 'Default' && this.value() * track.offsetWidth / 100 > track.offsetWidth - 20) {
            return true;
          }
        }
        return false;
      });
      this.invertBackwardButtonColor = computed(() => {
        const track = this.track()?.nativeElement;
        if (track) {
          if (this.type() === 'Range' && this.minRangeValue() * track.offsetWidth / 100 < 20 || this.type() === 'Default' && this.value() * track.offsetWidth / 100 > 20) {
            return true;
          }
        }
        return false;
      });
      this.invertRightArrowButtonColor = computed(() => this.isRtl() ? this.invertBackwardButtonColor() : this.invertForwardButtonColor());
      this.invertLeftArrowButtonColor = computed(() => this.isRtl() ? this.invertForwardButtonColor() : this.invertBackwardButtonColor());
      this.invertIconColor = computed(() => {
        const track = this.track()?.nativeElement;
        if (track) {
          if (this.type() === 'Default' && this.value() * track.offsetWidth / 100 > 20) {
            return true;
          }
        }
        return false;
      });
      this.range = computed(() => this.maxValue() - this.minValue());
      this.progressWidth = computed(() => (this.isRange() ? (this.maxRangeValue() - this.minRangeValue()) * 100 / this.range() : (this.value() - this.minValue()) * 100 / this.range()) + '%');
      this.getMinNumberSliderTransform = computed(() => {
        return {
          transform: `translateY(-${(this.minRangeValue() - this.minValue()) * amountLabelLineHeight / this.stepSize()}px)`
        };
      });
      this.getMaxNumberSliderTransform = computed(() => {
        return {
          transform: `translateY(-${(this.maxRangeValue() - this.minValue()) * amountLabelLineHeight / this.stepSize()}px)`
        };
      });
      this.getHeightOffsetOfAmountLabel = computed(() => this.isRange() ? this.maxRangeValue() - this.minRangeValue() : this.value() - this.minValue());
      this.getNumberSliderTransform = computed(() => {
        return {
          transform: `translateY(-${this.getHeightOffsetOfAmountLabel() * amountLabelLineHeight / this.stepSize()}px)`
        };
      });
      this.steps = computed(() => this.range() / this.stepSize());
      this.ticks = computed(() => Array.from({
        length: this.steps() + 1
      }, (_, i) => this.minValue() + i * this.stepSize()));
      this.progressStyle = computed(() => {
        return {
          right: this.isRtl() ? this.isRange() ? this.minRangeValue() * 100 / this.range() + '%' : 0 : 'unset',
          left: !this.isRtl() ? this.isRange() ? this.minRangeValue() * 100 / this.range() + '%' : 0 : 'unset',
          width: this.progressWidth()
        };
      });
      this.selectValue = output();
      effect(() => {
        const defaultValue = this.value();
        const fromValue = this.minRangeValue();
        const toValue = this.maxRangeValue();
        this.selectValue.emit({
          default: defaultValue,
          range: {
            from: fromValue,
            to: toValue
          }
        });
      });
    }
    ngOnInit() {
      this.selectedMinValue$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: value => {
          if (value >= 0) {
            this.minRangeValue.set(value);
          }
        }
      });
      this.selectedMaxValue$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: value => {
          if (value >= 0) {
            this.maxRangeValue.set(value);
          }
        }
      });
    }
    onThumbStart(event, thumb) {
      this.isDragging.set(true);
      this.draggingThumb = thumb;
      event.preventDefault();
    }
    onWindowMouseUp() {
      this.isDragging.set(false);
      this.draggingThumb = null;
    }
    onMove(event) {
      if (!this.isDragging() || !this.draggingThumb) return;
      const clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
      this.updateValueFromEvent(clientX);
    }
    onTrackClick(event) {
      const clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
      this.updateValueFromEvent(clientX);
    }
    forwardButtonClick(event) {
      if (this.isRange() ? this.maxRangeValue() >= this.maxValue() : this.value() >= this.maxValue()) {
        return;
      }
      if (this.isRange()) {
        this.maxRangeValue.update(value => Math.min(value + this.stepSize(), this.maxValue()));
      } else {
        this.value.update(value => Math.min(value + this.stepSize(), this.maxValue()));
      }
      event.stopPropagation();
    }
    backwardButtonClick(event) {
      if (this.isRange() ? this.minRangeValue() <= this.minValue() : this.value() <= this.minValue()) {
        return;
      }
      if (this.isRange()) {
        this.minRangeValue.update(value => Math.max(value - this.stepSize(), this.minValue()));
      } else {
        this.value.update(value => Math.max(value - this.stepSize(), this.minValue()));
      }
      event.stopPropagation();
    }
    snapToStep(rawValue) {
      const nearestStep = Math.round(rawValue / this.stepSize()) * this.stepSize();
      return Math.max(this.minValue(), Math.min(this.maxValue(), nearestStep));
    }
    // private updateValueFromEvent(clientX: number) {
    //   const track = document.querySelector('.ngx-slider-track')!.getBoundingClientRect();
    //   let newValue = (((clientX - track.left) / track.width) * this.range()) + this.minValue()
    //   console.log(newValue)
    //   newValue = this.snapToStep(newValue);
    //
    //   if (this.isRange()) {
    //     if (this.draggingThumb === 'min' && newValue < this.maxRangeValue()) {
    //       this.minRangeValue.set(newValue);
    //     } else if (this.draggingThumb === 'max' && newValue > this.minRangeValue()) {
    //       this.maxRangeValue.set(newValue);
    //     }
    //   } else {
    //     this.value.set(newValue);
    //   }
    // }
    updateValueFromEvent(clientX) {
      const track = document.querySelector('.ngx-slider-track').getBoundingClientRect();
      // Calculate new value based on RTL direction
      let newValue = this.direction() === 'rtl' ? (track.right - clientX) / track.width * this.range() + this.minValue() : (clientX - track.left) / track.width * this.range() + this.minValue();
      newValue = this.snapToStep(newValue);
      if (this.isRange()) {
        if (this.draggingThumb === 'min' && newValue <= this.maxRangeValue()) {
          this.minRangeValue.set(newValue);
        } else if (this.draggingThumb === 'max' && newValue >= this.minRangeValue()) {
          this.maxRangeValue.set(newValue);
        }
      } else {
        this.value.set(newValue);
      }
    }
    static {
      this.ɵfac = function NgxSliderComponent_Factory(t) {
        return new (t || NgxSliderComponent)(i0.ɵɵdirectiveInject(i0.DestroyRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxSliderComponent,
        selectors: [["ngx-slider-selector"]],
        viewQuery: function NgxSliderComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.track, _c0, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        hostBindings: function NgxSliderComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mouseup", function NgxSliderComponent_mouseup_HostBindingHandler() {
              return ctx.onWindowMouseUp();
            }, false, i0.ɵɵresolveWindow)("touchend", function NgxSliderComponent_touchend_HostBindingHandler() {
              return ctx.onWindowMouseUp();
            }, false, i0.ɵɵresolveWindow)("mousemove", function NgxSliderComponent_mousemove_HostBindingHandler($event) {
              return ctx.onMove($event);
            }, false, i0.ɵɵresolveWindow)("touchmove", function NgxSliderComponent_touchmove_HostBindingHandler($event) {
              return ctx.onMove($event);
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          sliderType: [i0.ɵɵInputFlags.SignalBased, "sliderType"],
          type: [i0.ɵɵInputFlags.SignalBased, "type"],
          stepSize: [i0.ɵɵInputFlags.SignalBased, "stepSize"],
          showLabel: [i0.ɵɵInputFlags.SignalBased, "showLabel"],
          showTopLabel: [i0.ɵɵInputFlags.SignalBased, "showTopLabel"],
          value: [i0.ɵɵInputFlags.SignalBased, "value"],
          minValue: [i0.ɵɵInputFlags.SignalBased, "minValue"],
          maxValue: [i0.ɵɵInputFlags.SignalBased, "maxValue"],
          selectedMinValue: [i0.ɵɵInputFlags.SignalBased, "selectedMinValue"],
          selectedMaxValue: [i0.ɵɵInputFlags.SignalBased, "selectedMaxValue"],
          unitName: [i0.ɵɵInputFlags.SignalBased, "unitName"],
          unitSymbol: [i0.ɵɵInputFlags.SignalBased, "unitSymbol"],
          direction: [i0.ɵɵInputFlags.SignalBased, "direction"]
        },
        outputs: {
          value: "valueChange",
          selectValue: "selectValue"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 13,
        vars: 17,
        consts: [["track", ""], [1, "ngx-slider-main-container"], [1, "ngx-slider-container"], [1, "ngx-slider-amount-label", "fw-medium", "mb-minus", "gap-tiny", "d-flex", "flex-row", "justify-content-center", "align-items-center", 3, "rtl", "ltr"], [1, "ngx-slider-track", "d-flex", "align-items-center", "radius-mini", 3, "click"], [1, "ngx-slider-progress", 3, "ngStyle"], [1, "ngx-slider-thumb", 3, "first", "grabbing"], [1, "ngx-slider-thumb", 3, "grabbing", "last", "first"], [1, "ngx-slider-icon-img", "d-flex", "flex-column", "justify-content-center", "align-items-center", 3, "invert", "is-rtl"], [1, "d-flex", "fs-14", "mt-pony", "justify-content-space-between", 3, "rtl", "ltr"], [1, "ngx-slider-amount-label", "fw-medium", "mb-minus", "gap-tiny", "d-flex", "flex-row", "justify-content-center", "align-items-center"], [1, "ngx-slider-number-container", "fs-32"], [1, "number-slider", "d-flex", "flex-column", "justify-content-flex-start", 3, "ngStyle"], [1, "rtl"], [1, "ngx-slider-currency", "fs-18", "is-currency", "rtl"], [1, "ngx-slider-intercept", "fs-18", "fw-bold", "mx-minus"], [1, "ngx-slider-currency", "fs-18", "rtl"], [1, "ngx-slider-currency", "fs-18", "is-currency"], [1, "ngx-slider-thumb", 3, "mousedown", "touchstart"], [1, "thumb-value", "fs-14", "fw-bold"], [1, "ngx-slider-tick", 3, "first", "last", "right", "left"], [1, "ngx-slider-tick"], [1, "ngx-slider-arrow-button", "d-flex", "flex-column", "justify-content-center", "align-items-center", "forward", 3, "click"], ["xmlns", "http://www.w3.org/2000/svg", "width", "6", "height", "10", "viewBox", "0 0 6 10", "fill", "none"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M1.0684 7.84403C0.775412 8.13603 0.773411 8.61103 1.0664 8.90503C1.2134 9.05203 1.4054 9.12503 1.5974 9.12503C1.7894 9.12503 1.9804 9.05203 2.1274 8.90603L5.5184 5.53003C5.6604 5.38903 5.7394 5.19803 5.7394 4.99803C5.7394 4.79903 5.6604 4.60803 5.5184 4.46703L2.1274 1.09003C1.8344 0.797029 1.3594 0.799029 1.0664 1.09203C0.773411 1.38603 0.775412 1.86103 1.0684 2.15303L3.9264 4.99803L1.0684 7.84403Z", "fill", "#74777C"], [1, "ngx-slider-arrow-button", "d-flex", "flex-column", "justify-content-center", "align-items-center", "backward", 3, "click"], [1, "ngx-slider-icon-img", "d-flex", "flex-column", "justify-content-center", "align-items-center"], ["width", "24", "height", "24", "viewBox", "0 0 24 24", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M11.7603 18.958C11.7461 19.9956 12.4087 20.7102 13.4043 20.9104C17.8984 21.8144 20.5177 16.294 16.4803 13.8126C15.3981 13.0715 13.8636 12.6026 14.8469 11.885C16.2551 10.8569 16.9085 12.3493 18.3487 12.3691C19.3863 12.3834 20.1009 11.7207 20.3011 10.7252C21.2051 6.23099 15.6847 3.61176 13.2033 7.64906C12.4622 8.73133 11.9933 10.2658 11.2757 9.28252C10.2476 7.87435 11.74 7.22099 11.7598 5.7808C11.774 4.74309 11.1114 4.02859 10.1158 3.82836C5.62166 2.92434 3.00244 8.4448 7.03974 10.9262C8.122 11.6672 9.65645 12.1362 8.67318 12.8538C7.265 13.8819 6.61162 12.3894 5.17143 12.3696C4.13372 12.3554 3.41921 13.0181 3.21898 14.0136C2.31496 18.5077 7.83543 21.127 10.3168 17.0897C11.0579 16.0074 11.5268 14.473 12.2444 15.4562C13.2725 16.8644 11.7801 17.5178 11.7603 18.958Z", "stroke", "#74777C", "stroke-width", "1.5", "stroke-miterlimit", "10"], ["d", "M11.76 15.1317C13.2856 15.1317 14.5223 13.895 14.5223 12.3694C14.5223 10.8438 13.2856 9.60706 11.76 9.60706C10.2344 9.60706 8.99765 10.8438 8.99765 12.3694C8.99765 13.895 10.2344 15.1317 11.76 15.1317Z", "stroke", "#74777C", "stroke-width", "1.5", "stroke-linecap", "round", "stroke-linejoin", "round"], [1, "d-flex", "fs-14", "mt-pony", "justify-content-space-between"]],
        template: function NgxSliderComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
            i0.ɵɵtemplate(2, NgxSliderComponent_Conditional_2_Template, 3, 6, "div", 3);
            i0.ɵɵelementStart(3, "div", 4, 0);
            i0.ɵɵlistener("click", function NgxSliderComponent_Template_div_click_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onTrackClick($event));
            });
            i0.ɵɵelementStart(5, "div", 5);
            i0.ɵɵtemplate(6, NgxSliderComponent_Conditional_6_Template, 2, 5, "div", 6)(7, NgxSliderComponent_Conditional_7_Template, 1, 6, "div", 7)(8, NgxSliderComponent_Conditional_8_Template, 1, 6, "div", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, NgxSliderComponent_Conditional_9_Template, 2, 0)(10, NgxSliderComponent_Conditional_10_Template, 6, 8)(11, NgxSliderComponent_Conditional_11_Template, 4, 4, "span", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(12, NgxSliderComponent_Conditional_12_Template, 5, 8, "div", 9);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵclassMap(i0.ɵɵpureFunction3(13, _c1, ctx.sliderType().toLowerCase(), ctx.type().toLowerCase(), ctx.value() ? "has-value" : ""));
            i0.ɵɵclassProp("is-rtl", ctx.isRtl());
            i0.ɵɵadvance();
            i0.ɵɵconditional(2, ctx.sliderType() === "Amount" && ctx.showLabel() ? 2 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngStyle", ctx.progressStyle());
            i0.ɵɵadvance();
            i0.ɵɵconditional(6, !ctx.isRange() ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(7, ctx.isRange() ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(8, ctx.isRange() ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(9, ctx.sliderType() === "Slider" || ctx.sliderType() === "Icon" ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(10, ctx.sliderType() === "Amount" ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(11, ctx.sliderType() === "Icon" ? 11 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(12, ctx.sliderType() === "Slider" && ctx.showLabel() ? 12 : -1);
          }
        },
        dependencies: [NgStyle],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}[_nghost-%COMP%]{display:block;width:100%}*[_ngcontent-%COMP%]{-webkit-user-select:none;user-select:none;font-family:inherit;box-sizing:content-box}.ngx-slider-main-container[_ngcontent-%COMP%]{direction:rtl;width:100%;--default-background: rgba(17, 89, 252, .7);--pressed-background: #1159FC;--dark-blue-color: #000060;--tick-width: 5px;--tick-height: 5px;--tick-border-radius: 50%;--tick-opacity: 0;--button-container-opacity: 0;--progress-transition: width $transition-base-time $transition-base-function}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]{width:100%;position:relative;transition:ease all .5s}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.slider[_ngcontent-%COMP%]{--track-height: 16px;--thumb-background: var(--pressed-background);--thumb-border-radius: 50%}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.slider.default[_ngcontent-%COMP%], .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.slider.range[_ngcontent-%COMP%]{--progress-height: 16px;--progress-background: var(--default-background);--progress-border-radius: 6px;--thumb-width: 16px;--thumb-height: 16px;--thumb-background: var(--pressed-background);--thumb-border: 4px solid #EAEFF7}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.slider.range[_ngcontent-%COMP%]{--progress-height: 22px;--progress-transition: background-color $transition-base-time $transition-base-function}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.slider[_ngcontent-%COMP%]:hover{--progress-height: 24px;--progress-background: var(--pressed-background);--progress-border-radius: 24px 4px 4px 24px;--thumb-width: 16px;--thumb-height: 16px;--thumb-border: 4px solid #FFFFFF;--thumb-box-shadow: 0px 0px 0px 4px #EAEFF7;--tick-opacity: 1}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.slider.is-rtl[_ngcontent-%COMP%]:hover{--progress-border-radius: 4px 24px 24px 4px}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.amount[_ngcontent-%COMP%], .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.icon[_ngcontent-%COMP%]{--track-height: 28px;--thumb-border-radius: 12px;--progress-height: var(--track-height);--progress-border-radius: 6px 0 0 6px;--thumb-width: 4px;--thumb-height: var(--track-height);--track-border-left: 6px solid #EAEFF7;--track-border-right: 6px solid #EAEFF7}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.amount.is-rtl[_ngcontent-%COMP%], .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.icon.is-rtl[_ngcontent-%COMP%]{--progress-border-radius: 0 6px 6px 0}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.amount.default[_ngcontent-%COMP%], .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.amount.range[_ngcontent-%COMP%], .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.icon.default[_ngcontent-%COMP%], .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.icon.range[_ngcontent-%COMP%]{--thumb-background: var(--pressed-background);--progress-background: var(--default-background)}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.amount.default.has-value[_ngcontent-%COMP%], .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.amount.range.has-value[_ngcontent-%COMP%], .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.icon.default.has-value[_ngcontent-%COMP%], .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.icon.range.has-value[_ngcontent-%COMP%]{--progress-border-radius: 0;--track-border-left: 6px solid #EAEFF7}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.amount.default.has-value[_ngcontent-%COMP%], .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.icon.default.has-value[_ngcontent-%COMP%]{--track-border-left: 6px solid var(--progress-background);--track-border-right: 6px solid #EAEFF7}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.amount.default.has-value.is-rtl[_ngcontent-%COMP%], .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.icon.default.has-value.is-rtl[_ngcontent-%COMP%]{--track-border-left: 6px solid #EAEFF7;--track-border-right: 6px solid var(--progress-background)}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.amount.range[_ngcontent-%COMP%], .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.icon.range[_ngcontent-%COMP%]{--progress-transition: background-color $transition-base-time $transition-base-function;--progress-border-radius: 0}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.amount[_ngcontent-%COMP%]:hover, .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.icon[_ngcontent-%COMP%]:hover{--thumb-background: var(--dark-blue-color);--progress-background: var(--pressed-background);--tick-opacity: 1;--button-container-opacity: 1}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.amount[_ngcontent-%COMP%]:hover.range.has-value, .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.icon[_ngcontent-%COMP%]:hover.range.has-value{--track-border-left: 6px solid #EAEFF7}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.amount[_ngcontent-%COMP%]:hover.default.has-value, .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.icon[_ngcontent-%COMP%]:hover.default.has-value{--track-border-left: 6px solid var(--progress-background);--track-border-right: 6px solid #EAEFF7}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.amount[_ngcontent-%COMP%]:hover.default.has-value.is-rtl, .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.icon[_ngcontent-%COMP%]:hover.default.has-value.is-rtl{--track-border-left: 6px solid #EAEFF7;--track-border-right: 6px solid var(--progress-background)}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.icon[_ngcontent-%COMP%]{--track-height: 48px;--tick-width: 1px;--tick-height: 48px;--tick-border-radius: 0}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-amount-label[_ngcontent-%COMP%]   .ngx-slider-number-container[_ngcontent-%COMP%]{width:fit-content;line-height:56px;max-height:56px;overflow-y:hidden}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-amount-label[_ngcontent-%COMP%]   .ngx-slider-number-container[_ngcontent-%COMP%]   .number-slider[_ngcontent-%COMP%]{transition:transform .5s ease}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-amount-label[_ngcontent-%COMP%]   .ngx-slider-number-container[_ngcontent-%COMP%]   .number-slider[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{text-align:left}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-amount-label[_ngcontent-%COMP%]   .ngx-slider-currency[_ngcontent-%COMP%], .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-amount-label[_ngcontent-%COMP%]   .ngx-slider-intercept[_ngcontent-%COMP%]{line-height:32px}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-progress[_ngcontent-%COMP%]{position:absolute;height:var(--progress-height);background-color:var(--progress-background);border-radius:var(--progress-border-radius);z-index:2;transition:var(--progress-transition)}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-progress[_ngcontent-%COMP%]   .ngx-slider-thumb[_ngcontent-%COMP%]{position:absolute;width:var(--thumb-width);height:var(--thumb-height);background-color:var(--thumb-background);border:var(--thumb-border);box-shadow:var(--thumb-box-shadow, \"none\");border-radius:var(--thumb-border-radius);top:50%;transition:all .5s ease;transform:translate(50%,-50%);cursor:grab;z-index:3}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-progress[_ngcontent-%COMP%]   .ngx-slider-thumb.first[_ngcontent-%COMP%]{left:0;transform:translate(-50%,-50%)}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-progress[_ngcontent-%COMP%]   .ngx-slider-thumb.last[_ngcontent-%COMP%]{right:0}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-progress[_ngcontent-%COMP%]   .ngx-slider-thumb[_ngcontent-%COMP%]   .thumb-value[_ngcontent-%COMP%]{position:absolute;top:-28.5px;left:50%;transform:translate(-50%);line-height:24px}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-progress[_ngcontent-%COMP%]   .ngx-slider-thumb.grabbing[_ngcontent-%COMP%]{cursor:grabbing}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.amount[_ngcontent-%COMP%]   .ngx-slider-progress[_ngcontent-%COMP%]   .ngx-slider-thumb[_ngcontent-%COMP%]{transform:translate(50%,-49%)}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container.amount[_ngcontent-%COMP%]   .ngx-slider-progress[_ngcontent-%COMP%]   .ngx-slider-thumb.first[_ngcontent-%COMP%]{transform:translate(-50%,-49%)}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-track[_ngcontent-%COMP%]{position:relative;height:var(--track-height);background-color:#eaeff7;border-right:var(--track-border-right);border-left:var(--track-border-left);cursor:pointer}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-track[_ngcontent-%COMP%]   .ngx-slider-tick[_ngcontent-%COMP%]{position:absolute;opacity:var(--tick-opacity);width:var(--tick-width);height:var(--tick-height);background-color:#c9cbcf;border-radius:var(--tick-border-radius);top:50%;transform:translate(-50%,-50%);transition:opacity .5s ease;z-index:1}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-track[_ngcontent-%COMP%]   .ngx-slider-tick.last[_ngcontent-%COMP%], .ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-track[_ngcontent-%COMP%]   .ngx-slider-tick.first[_ngcontent-%COMP%]{display:none!important}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-track[_ngcontent-%COMP%]   .ngx-slider-arrow-button[_ngcontent-%COMP%]{opacity:var(--button-container-opacity);position:absolute;top:50%;z-index:3;transition:opacity .5s ease;transform:translateY(-50%);cursor:pointer;width:19px;height:19px;background-color:#b4b7bd;border-radius:6px}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-track[_ngcontent-%COMP%]   .ngx-slider-arrow-button.forward[_ngcontent-%COMP%]{right:0}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-track[_ngcontent-%COMP%]   .ngx-slider-arrow-button.backward[_ngcontent-%COMP%]{left:0;transform:translateY(-50%) rotate(180deg)}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-track[_ngcontent-%COMP%]   .ngx-slider-arrow-button[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:#74777c}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-track[_ngcontent-%COMP%]   .ngx-slider-arrow-button.invert[_ngcontent-%COMP%]{background-color:var(--default-background)}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-track[_ngcontent-%COMP%]   .ngx-slider-arrow-button.invert[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:#fff}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-track[_ngcontent-%COMP%]   .ngx-slider-arrow-button.hide[_ngcontent-%COMP%]{opacity:0;visibility:hidden}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-track[_ngcontent-%COMP%]   .ngx-slider-icon-img[_ngcontent-%COMP%]{width:24px;height:24px;position:absolute;top:50%;left:12px;transform:translateY(-50%);z-index:4}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-track[_ngcontent-%COMP%]   .ngx-slider-icon-img.is-rtl[_ngcontent-%COMP%]{left:unset;right:12px}.ngx-slider-main-container[_ngcontent-%COMP%]   .ngx-slider-container[_ngcontent-%COMP%]   .ngx-slider-track[_ngcontent-%COMP%]   .ngx-slider-icon-img.invert[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:#fff}"],
        changeDetection: 0
      });
    }
  }
  return NgxSliderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgxSliderComponent };
